'use client';
import type { FC, ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { Button, type ButtonProps } from '@/app/components/ui/button';
import { cn, formatCount } from '@/app/utils';

interface CountButtonProps {
  count: number;
  active?: boolean;
  className?: string;
  numClassName?: string;
  handleActive?: () => void;
  handleUnActive?: () => void;
  activeIcon: ReactElement;
  unActiveIcon: ReactElement;
  enableClick?: boolean;
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
  hideEmptyCount?: boolean;
  hideCount?: boolean;
}

const CountButton: FC<CountButtonProps> = ({
  count,
  active,
  className,
  activeIcon,
  unActiveIcon,
  numClassName,
  handleActive,
  handleUnActive,
  enableClick = true,
  size = 'original',
  variant = 'text',
  hideEmptyCount = false,
  hideCount = false,
}) => {
  const [isActive, setIsActive] = useState(active);
  const [activeCount, setActiveCount] = useState(count);

  useEffect(() => {
    setIsActive(active);
    setActiveCount(count);
  }, [active, count]);

  return (
    <Button
      variant={variant}
      size={size}
      className={cn('flex items-center justify-center gap-1', className)}
      onClick={(e) => {
        if (enableClick) {
          e.stopPropagation();
          if (isActive) {
            handleUnActive?.();
            setIsActive(false);
            setActiveCount(activeCount - 1);
          } else {
            handleActive?.();
            setIsActive(true);
            setActiveCount(activeCount + 1);
          }
        }
      }}
    >
      {isActive ? activeIcon : unActiveIcon}
      {!(hideEmptyCount && !activeCount) && !hideCount && (
        <div className={cn('min-w-[1ch] text-sm', numClassName)}>{formatCount(activeCount || 0)}</div>
      )}
    </Button>
  );
};

export default CountButton;
